"use client";

import { useState, useEffect } from "react";
import { Copy } from "lucide-react";
import CopyPopup from "../../components/Popup/CopyPopup";

export default function ReferralBar({ referralCode }) {
  const [copied, setCopied] = useState(false);
  const [copyPopup, setCopyPopup] = useState(false);

  useEffect(() => {
    console.log("Referral", referralCode);
  }, [referralCode]);

  return (
    <>
      <div className="px-8 my-5 max-xs:my-3 max-xs:px-8 ">
        <div className="flex items-center border border-gray-200 rounded-full overflow-hidden bg-white">
          <div className="flex-1 px-3.5 ">
            <span className="text-[#12131A] font-normal text-sm max-xs:text-xs">
              Referral No. :{" "}
            </span>
            <span className="text-[#12131A] font-normal text-sm max-xs:text-xs">{referralCode}</span>
          </div>
          <button
            onClick={()=>setCopyPopup(true)}
            className="px-4 py-1  bg-[#0E64D1] text-white hover:bg-blue-700 transition-colors flex items-center gap-1 text-sm max-xs:text-xs "
          >
            COPY
            <Copy className="w-4 h-4 max-xs:w-3 max-xs:h-3" />
          </button>
        </div>
      </div>

      <CopyPopup isOpen={copyPopup} onClose={() => setCopyPopup(false)} referralCode={referralCode} />
    </>
  );
}
